import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./components/Auth/index";
import SetPasswordPage from "./components/Auth/SetPasswordPage";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import UserPage from "./components/User";
import HomeDashboard from "./components/Dashboard";
import MissionsPage from "./components/Mission";
import CalendarModule from "./components/Calendar";
import QuotePage from "./components/Quote";
import InvestorPage from "./components/Investor";
import SalaryManagementPage from "./components/Salary/SalaryManagementPage";
import HomePage from "./components/HomePage";
import InvoicesPage from "./components/Invoice";
import NotificationsPage from "./components/Notifications/NotificationsPage";
import NotificationDetail from "./components/Notifications/NotificationDetail";
import CataloguePage from "./components/Inventory/CataloguePage";
import SettingsPage from "./components/Settings";
import OrganizationsPage from "./components/Admin/Organizations";
import OrganizationDetail from "./components/Admin/OrganizationDetail";
import ProfilePage from "./components/Profile";
import PerformancePage from "./components/Performance";
import SubcontractorsPage from "./components/Subcontractors";
import Layout from "./components/Layout";

function App() {
  return (
    <div className="w-full">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/set-password" element={<SetPasswordPage />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<HomePage />} />
          <Route
            path="dashboard"
            element={
              <ProtectedRoute permission="dashboard">
                <HomeDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="missions"
            element={
              <ProtectedRoute permission="missions">
                <MissionsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="quotes"
            element={
              <ProtectedRoute permission="quote">
                <QuotePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="invoices"
            element={
              <ProtectedRoute permission="invoices">
                <InvoicesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="calendar"
            element={
              <ProtectedRoute permission="appointments">
                <CalendarModule />
              </ProtectedRoute>
            }
          />
          <Route
            path="investors"
            element={
              <ProtectedRoute permission="investors">
                <InvestorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="users"
            element={
              <ProtectedRoute permission="users">
                <UserPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="salaries"
            element={
              <ProtectedRoute permission="salaries">
                <SalaryManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="notifications"
            element={
              <ProtectedRoute permission="dashboard">
                <NotificationsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="notifications/:id"
            element={
              <ProtectedRoute permission="dashboard">
                <NotificationDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="catalogue"
            element={
              <ProtectedRoute permission="quote">
                <CataloguePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="subcontractors"
            element={
              <ProtectedRoute permission="subcontractors">
                <SubcontractorsPage />
              </ProtectedRoute>
            }
          />
          <Route path="settings" element={<SettingsPage />} />
          <Route
            path="admin/organizations"
            element={
              <ProtectedRoute superadminOnly>
                <OrganizationsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="admin/organizations/:id"
            element={
              <ProtectedRoute superadminOnly>
                <OrganizationDetail />
              </ProtectedRoute>
            }
          />
          <Route path="profile" element={<ProfilePage />} />
          <Route
            path="performance"
            element={
              <ProtectedRoute adminOnly>
                <PerformancePage />
              </ProtectedRoute>
            }
          />
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </div>
  );
}

export default App;
